import ImageBase64 from '../components/partials/base64-image.js';

export default {
    redirectOnResetPassword (){
        return null;
    },
    emailOnRegisterSetPasswordLinkFormat (){
        let uri = '/#/set-password/?token={token}&email={email}';
        if(!window.location.origin){
            return uri;
        }
        let url = new URL(uri, window.location.origin);
        return url.href;
    },
    emailOnRegisterContentFormat (){
        return null;
    },
    alertFieldsToHide (){
        return [];
    },
    allowAlertsAlarmsNotification() {
        return false;
    },
    allowFilterAlarms() {
        return false;
    },
    allowLanguageSwitch() {
        return false;
    },
    appLangEntries() {
        return {};
    },
    backgroundFile1(/*state, getters, rootState*/) {
        // return getters.currentEntity.background_file_1;
        return ImageBase64.backgroundFile1;
    },
    backgroundFile2(/*state, getters, rootState*/) {
        // return getters.currentEntity.background_file_2;
        return ImageBase64.backgroundFile2;
    },
    darkMode() {
        return false;
    },
    defaultLanguage(state, getters) {
        let navigatorLanguage = navigator.languages;
        let languagesAvailable = getters.languagesAvailable.map(entry => entry.value)
        let appLanguage = 'en';
        if (localStorage.getItem('app_lang')) {
            return localStorage.getItem('app_lang');
        }
        if (navigatorLanguage) {
            navigatorLanguage = navigatorLanguage.filter(opt => !opt.includes('-')).reverse();
        }
        navigatorLanguage.forEach(opt => {
            if (languagesAvailable.includes(opt)) {
                appLanguage = opt;
            }
        });
        return appLanguage;
    },
    displayAppSearchBar (){
        return true;
    },
    displayAuthFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.userIsAuthenticated;
    },
    displayGroupsColumnInUsersTable() {
        return true;
    },
    displayFirstLastNameColumnInUsersTable() {
        return false;
    },
    displayLoadingFullOverlay(state, getters, rootState, rootGetters){
        // Needs this to be true in order to allow user to select a scope
        return !rootGetters.modelsUnscopedLoaded;
    },
    enableCreateGroup(){
        return false;
    },
    enableCreateUser(){
        return false;
    },
    enableCreateUserByImportCsv(){
        return false;
    },
    enableDeleteGroup() {
        return true;
    },
    enableDownloadCsvGroups(){
        return false;
    },
    enableDownloadCsvUsers(){
        return false;
    },
    enableGroupsAdministration(){
        return true;
    },
    enableGroupsSideBarMenu(){
        return true;
    },
    enableLoginByEmail(){
        return false;
    },
    enableManageNotifications() {
        return false;
    },
    enableManageOtherUsersNotifications() {
        return false;
    },
    enableOptions() {
        return true;
    },
    enablePermissionAdministration(){
        return true;
    },
    enableRegister(){
        return false;
    },
    enableResetPassword(){
        return false;
    },
    enableSidebarCollapse(){
        return false;
    },
    enableUnblockUser (){
        return false;
    },
    enableUsersAdministration(){
        return true;
    },
    enableUsersSideBarMenu(){
        return true;
    },
    getDashboardTopRightExtraTemplate(){
        return null;
    },
    getScopeModelKey() {
        // in order to manage notifications in profile vue
        // model should be the name of the scoped model
        // key should be the name of the field used as the scope in the users model
        return {
            model: '',
            key: ''
        };
    },
    languagesAvailable() {
        return [
            {
                value: 'en',
                verbose: 'English'
            },
            {
                value: 'fr',
                verbose: 'Français'
            },
        ];
    },
    LDAPConnectionAvailable() {
        return false;
    },
    LDAPTabName() {
        return 'Login LDAP';
    },
    LDAPConnectionRoute() {
        return 'auth/ldap/login/';
    },
    loginImage(){
        return ImageBase64.loginImage;
    },
    logoFile(/*state, getters, rootState*/) {
        // return getters.currentEntity.logo_file;
        return ImageBase64.logoFile;
    },
    logoFileBackgroundColor(/*state, getters, rootState*/) {
        return 'transparent';
    },
    logoFileTopHeader(/*state, getters*/) {
        // return getters.currentEntity.logo_file_topHeader;
        return ImageBase64.logoFileTopHeader;
    },
    logoFileTopHeaderBackgroundColor(/*state, getters*/) {
        return '#333';
    },
    showAlarms() {
        return false;
    },
    showAlerts() {
        return false;
    },
    sidebarName(state, getters /*rootState, rootGetters*/){
        // let entity = rootGetters.currentEntity;
        // if(entity){
        //     return entity.verbose_name ? entity.verbose_name : entity.name;
        // }
        // return 'loading';
        return getters.getVerbose('sidebar_default_name');
    },
    userExtraEditableFields(){
        return {
            first_name: 'First Name',
            last_name: 'Last Name',
        };
    },
    // Une autre getters à été créer plutot que de mofier le précédent afin d'assurer la rétrocompatibilité
    userExtraEditableFieldsOptions(){
        return {
            first_name: { type: 'string' },
            last_name: { type: 'string' },
        };
    },
    usersCanViewTheirOwnGroups(/*state, getters*/) {
        return false;
    },

    // ce getter ne serait-il pas propre à MADY ? QAM - 2 / 08 / 2019
    enableManageAccessPreview() {
        return false;
    },

    // getters not used in fundation QAM - 2 / 08 / 2019
    autoConnectionToFirstEntity(state, getters, rootState, rootGetters){
        if(rootGetters.hasMultipleEntities){
            return false;
        }
        return true;
    },
    canDeleteGroup() {
        return {
            'allowed': false,
            'message': '',
        };
    },
    canEditUser() {
        return false;
    },
    dashboardName(state, getters/*, rootState, rootGetters*/){
        return getters.getVerbose('dashboard_default_name');
    },
    defaultLogoFileTopHeader(){
        return null;
    },
    defaultStyleTopHeader(state, getters/*, rootState, rootGetters*/){
        if(getters.defaultLogoFileTopHeader){
            return {
                'background-image': `url('${getters.defaultLogoFileTopHeader}')`,
            };
        }
        return {};
    },
    displayChooseEntityTopBar(/*state, getters, rootState, rootGetters*/){
        return false;
    },
    getChoosableActiveEntities(state, getters, rootState, rootGetters){
        return rootGetters.allEntities;
    },
    imgChooseEntityBg(/*state, getters, rootState, rootGetters*/){
        return ImageBase64.chooseEntityBg;
    },
    isCurrentUserAllowedToCreateEntity(/*state, getters, rootState, rootGetters*/){
        return false;
    },
    isFrontApp(/*state, getters, rootState, rootGetters*/){
        return false;
    },
    menuOptions(){
        return [];
    },
    platformName(state, getters){
        let platformName = getters.thisPlatformName;
        if(platformName === undefined || platformName === null){
            return getters.getVerbose('plateform_default_name');
        }
        return platformName;
    },
    sidebarMenuLinks(state) {
        return state.sidebarMenuLinks;
    },
    menuItemColors (){
        return {
            background: '#333',
            text: '#fff',
            activeText: '#ffd04b',
        };
    },
    shouldFetchModelAclRoles (){
        return true;
    },
    shouldFetchModelAclPermissions (){
        return true;
    },
    alertsFetchSidebarFilter (){
        return { acquited: false };
    },
    activeAlertsFetchFilter (){
        return  { acquited: false, archived: false };
    },
    inactivedAlertsFetchFilter (){
        return { acquited: true, archived: false };
    },
    archivedAlertsFetchFilter (){
        return { acquited: true, archived: true };
    },
    alarmSidebarFilter (state, getters, rootState, rootGetters){
        return rootGetters.alarms.filter((alarm) => {
            return alarm.active === true;
        }).length;
    },
    activeAlarms(state, getters, rootState, rootGetters) {
        return rootGetters.alarms.filter((alarm) => {
            return alarm.active === true;
        });
    },
    inactiveAlarms(state, getters, rootState, rootGetters) {
        return rootGetters.alarms.filter((alarm) => {
            return alarm.active === false;
        });
    },
    allAlarms(state, getters, rootState, rootGetters) {
        return getters.activeAlarms.concat(getters.inactiveAlarms);
    },
    groupCreationAdditionnalValidators(){
        // for example
        // return [
        //     (value) => {
        //         if (getters.masterGroups.find(mg => mg.name.toUpperCase() === value.toUpperCase()) !== undefined) {
        //             throw new Error('A master group already has this name');
        //         }
        //     },
        // ];
        return [];
    }

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/store/overridableGetters.js
// module id = null
// module chunks = 